// extracted by mini-css-extract-plugin
module.exports = {"aiChatPage":"WidgetSnippetModal_aiChatPage__zmnhb"};